'use client';

import {Cookie} from '@config/cookies';
import {useCookies} from '@hooks/useCookies';
import {ClientCookies} from '@utils/clientCookies';
import {usePathname} from 'next/navigation';
import {useEffect} from 'react';

export default function CookieHydration() {
    const setCookie = useCookies(state => state.hydrateSet);
    const pathName = usePathname();

    useEffect(() => {
        const reFetchCookies = async () => {
            for (const newCookie of ClientCookies.getAll()) {
                const oldCookie = ClientCookies.get(newCookie.name as Cookie);
                if (oldCookie?.value !== newCookie.value) {
                    setCookie(newCookie.name as Cookie, newCookie?.value);
                }
            }
        };

        reFetchCookies();
    }, [pathName]);

    return null;
}
